import { Lock } from 'lucide-react';
import { cn } from '@/lib/cn';

interface LockedInlineBadgeProps {
  label?: string;
  className?: string;
}

export function LockedInlineBadge({ label = 'XK+', className }: LockedInlineBadgeProps) {
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1 rounded px-1.5 py-0.5 text-[9px] font-extrabold uppercase tracking-wide',
        'bg-[var(--color-accent-15)] text-[var(--color-accent-ink)]',
        className,
      )}
      style={{ fontFamily: 'var(--font-display)' }}
    >
      <Lock className="h-2.5 w-2.5" />
      {label}
    </span>
  );
}
